import { render, staticRenderFns } from "./SliceProgrammeThumbLarge.vue?vue&type=template&id=0f1aa4e5&lang=pug&"
import script from "./SliceProgrammeThumbLarge.vue?vue&type=script&lang=js&"
export * from "./SliceProgrammeThumbLarge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports